// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"a3de9fb0","152":"60cec8e4","281":"75d01f7f","771":"ed9f8af4","825":"69b66352","887":"63244ae1","992":"b8a64228"}[chunkId] + ".chunk.css";
};